import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';

import useSession from 'core/hooks/use-session';
import greenCheck from 'core/assets/svg/green-check-white-bg.svg';
import { IncompleteTasksNotification } from 'common/components/notifications/incomplete-tasks-notification';
import { TransferToAgencyNotification } from 'common/components/notifications/transfer-to-agency-notification';
import { AgencyServicedByBranchNotification } from 'common/components/notifications/agency-serviced-by-branch';
import NotificationType from 'core/helpers/notifications';
import { NotificationCard } from 'core/components/notification-card';
import { useStore } from 'core/store';
import { SignedDocumentsNotification } from '../signed-documents-notification';
import { PendingThirdPartyNotification } from '../pending-third-party-notification';
import { CrossSellEligibilityNotification } from 'customer/components/cross-sell-eligibility-notification';
import { checkIsFarmEnvironment } from 'common/helpers/environment-helpers';

const isFarmEnvironment = checkIsFarmEnvironment();

const NotificationComponentType = {
  [NotificationType.Customer.AgencyServicedByBranch]: 'tertiary'
};

const NotificationIcons = {
  [NotificationType.Customer.AgencyServicedByBranch]: greenCheck
};

const Notification = {
  [NotificationType.Policy.CrossSellEligibility]: {
    component: CrossSellEligibilityNotification,
    shouldShow: !isFarmEnvironment
  },
  [NotificationType.Policy.SignedConversionDocuments]: {
    component: SignedDocumentsNotification,
    shouldShow: true
  },
  [NotificationType.Policy.PendingThirdPartyPurchases]: {
    component: PendingThirdPartyNotification,
    shouldShow: true
  },
  [NotificationType.Customer.IncompleteTasks]: {
    component: IncompleteTasksNotification,
    shouldShow: true
  },
  [NotificationType.Customer.TransferToAgency]: {
    component: TransferToAgencyNotification,
    shouldShow: !isFarmEnvironment
  },
  [NotificationType.Customer.AgencyServicedByBranch]: {
    component: AgencyServicedByBranchNotification,
    shouldShow: !isFarmEnvironment
  }
};

const PolicyNotifications = ({ onClick }) => {
  const {
    account: { policies: policiesStore },
    affinityLookups
  } = useStore();

  const [calledNotifications, setCalledNotifications] = useState(false);

  const { isAgency } = useSession();
  const loading = affinityLookups.loading || affinityLookups.partialLoading;

  useEffect(() => {
    // re-call set notifications once affinity lookups are loaded to render the affinity related notifications
    if (!loading && !calledNotifications) {
      policiesStore.setNotifications(isAgency);
      setCalledNotifications(true);
    }
  }, [affinityLookups, policiesStore, isAgency, calledNotifications, loading]);

  return (
    <Grid id="notificationsContainer">
      {policiesStore.notifications.map((notificationType) => {
        const { component: NotificationComponent, shouldShow } = Notification[notificationType];

        if (!shouldShow) {
          return null;
        }

        return (
          <NotificationCard
            key={notificationType}
            type={NotificationComponentType[notificationType]}
            icon={NotificationIcons[notificationType]}
          >
            <NotificationComponent onClick={onClick} fromPolicy />
          </NotificationCard>
        );
      })}
    </Grid>
  );
};

PolicyNotifications.propTypes = {
  onClick: PropTypes.func
};

PolicyNotifications.defaultProps = {
  onClick: null
};

export default observer(PolicyNotifications);
